import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { BottomNavigation, BottomNavigationAction, Paper, useMediaQuery, useTheme } from '@mui/material'
import {
  Home,
  List,
  Add,
} from '@mui/icons-material'

const MobileBottomNavigationMenu = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  const navItems = [
    { path: '/', label: 'Home', icon: Home },
    { path: '/flock-manager', label: 'Flock', icon: List },
    { path: '/add-entry', label: 'Add', icon: Add },
  ]

  const currentValue = navItems.findIndex(item => item.path === location.pathname)

  const handleChange = (event, newValue) => {
    navigate(navItems[newValue].path)
  }

  // Only show on mobile devices
  if (!isMobile) return null

  return (
    <Paper 
      sx={{ 
        position: 'fixed', 
        bottom: 0, 
        left: 0, 
        right: 0,
        paddingBottom: 'env(safe-area-inset-bottom)',
        zIndex: 100,
        display: { xs: 'block', md: 'none' }
      }}
      elevation={3}
      square
    >
      <BottomNavigation
        value={currentValue}
        onChange={handleChange}
        showLabels
        sx={{ height: 60 }}
      >
        {navItems.map(({ label, icon: Icon }, index) => (
          <BottomNavigationAction
            key={index}
            label={label}
            icon={<Icon />}
          />
        ))}
      </BottomNavigation>
    </Paper>
  )
}

export default MobileBottomNavigationMenu